import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuoteListComponent } from './quote-list/quote-list.component'
import { MatTableModule } from '@angular/material/table'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { QuoteDetailsComponent } from './quote-details/quote-details.component'
import { AddressLineComponent } from './quote-details/address-line/address-line.component'
import { LineItemsComponent } from './quote-details/line-items/line-items.component'
import { QuoteTrackingProductComponent } from './quote-details/quote-tracking-product/quote-tracking-product.component'
import {
  SpinnerModule,
  IconModule,
  FormErrorsModule,
  MediaModule,
  DIALOG_TYPE,
} from '@spartacus/storefront'
import {
  FeaturesConfigModule,
  UrlModule,
  I18nModule,
  ConfigModule,
  provideConfig,
} from '@spartacus/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { QuoteMergeModule } from './quote-merge/quote-merge.module'
import { QuotePendingActionComponent } from './quote-details/quote-pending-action/quote-pending-action.component'
import { QuoteMergeFooterLineComponent } from './quote-merge-footer-line/quote-merge-footer-line.component'
import { QuoteEditDialogComponent } from './quote-details/quote-edit-dialog/quote-edit-dialog.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { EditedQuoteDialogComponent } from './quote-details/edited-quote-dialog/edited-quote-dialog.component'
import { QuantityCounterModule } from '../../../shared/components/quantity-counter'
import { ScrollContainerModule } from '../../../shared/components/scroll-container/scroll-container.module'
import { StatusBubbleModule } from '../../../shared/components/status-bubble/status-bubble.module'
import { ClickOutsideModule } from '../../../shared/directive/clickOutside/click-outside.module'
import { StatusTilesModule } from '../../../shared/components/status-tiles/status-tiles.module'
import { DateRangePickerModule } from '../../../shared/components/date-range-picker/date-range-picker.module'
import { environment } from '../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [
    QuoteListComponent,
    QuoteDetailsComponent,
    AddressLineComponent,
    LineItemsComponent,
    QuoteTrackingProductComponent,
    QuotePendingActionComponent,
    QuoteMergeFooterLineComponent,
    QuoteEditDialogComponent,
    EditedQuoteDialogComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    StatusTilesModule,
    DateRangePickerModule,
    ReactiveFormsModule,
    SpinnerModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    ClickOutsideModule,
    I18nModule,
    MatIconModule,
    MatTooltipModule,
    FormErrorsModule,
    SpinnerModule,
    RouterModule,
    MediaModule,
    StatusBubbleModule,
    ScrollContainerModule,
    QuantityCounterModule,
    QuoteMergeModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteTracking'],
        },
      },
    }),
  ],
  exports: [QuoteListComponent],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.EDITED_QUOTE]: {
          inlineRoot: true,
          component: EditedQuoteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.QUOTE_EDIT]: {
          inlineRoot: true,
          component: QuoteEditDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class QuoteTrackingModule {}
